import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=1b2d2c66&"
import script from "./freight.vue?vue&type=script&lang=js&"
export * from "./freight.vue?vue&type=script&lang=js&"
import style0 from "./freight.vue?vue&type=style&index=0&id=1b2d2c66&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports